import { render, staticRenderFns } from "./eyebrow-icon.vue?vue&type=template&id=10951e31&scoped=true&"
import script from "./eyebrow-icon.vue?vue&type=script&lang=js&"
export * from "./eyebrow-icon.vue?vue&type=script&lang=js&"
import style0 from "./eyebrow-icon.vue?vue&type=style&index=0&id=10951e31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10951e31",
  null
  
)

export default component.exports